import api from '../../api/index.api'
import NotificationTypes from './notification.types'
import { DEFAULT_PAGE_SIZE } from '../../utils/constant'

export const onGetNotifications = (params = {}, cb) => {
	return async dispatch => {
		const page = Number.isFinite(Number(params.page))
			? Number(params.page)
			: 0
		const pageSize = Number.isFinite(Number(params.pageSize))
			? Number(params.pageSize)
			: DEFAULT_PAGE_SIZE
		try {
			const result = await api.notificationAdminApi.getNotifications(
				page,
				pageSize,
				{
					types: params.types,
				}
			)
			result.page = page + 1
			dispatch({
				type: NotificationTypes.GET_NOTIFICATIONS,
				payload: result,
			})
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onSelectNotifications = (data, cb) => {
	return async dispatch => {
		try {
			dispatch({
				type: NotificationTypes.SELECT_NOTIFICATIONS,
				payload: data,
			})
			cb && cb(true, data)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onAddNotification = (data, cb) => {
	return async dispatch => {
		try {
			const result = await api.notificationAdminApi.sendCustomNotification(data)
			dispatch({
				type: NotificationTypes.ADD_NOTIFICATION,
				payload: result,
			})
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onGetCustomNotificationSendJobStatus = (jobID, cb) => {
	return async () => {
		try {
			const result =
				await api.notificationAdminApi.getCustomNotificationSendJobStatus(jobID)
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onCancelCustomNotificationSendJob = (jobID, cb) => {
	return async () => {
		try {
			const result =
				await api.notificationAdminApi.cancelCustomNotificationSendJob(jobID)
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onDeleteNotificationAdmin = (params = {}, cb) => {
	return async () => {
		try {
			const result = await api.notificationAdminApi.deleteNotification(params.id)
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onDeleteManyNotificationsAdmin = (params = {}, cb) => {
	return async () => {
		try {
			const result = await api.notificationAdminApi.deleteManyNotifications(
				params.ids || []
			)
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}
